export const ALERTS_COUNT_ROUTE = 'api_alerts';
